import React, { Fragment } from 'react';
import opendoor1 from '../../../../../images/opendoor1.jpeg';
import opendoor2 from '../../../../../images/opendoor2.png';
import lockunlock1 from '../../../../../images/lockunlock1.png';
import lockunlock2 from '../../../../../images/lockunlock2.png';
import changegear from '../../../../../images/change-gear.png';
import mirrorwheel1 from '../../../../../images/mirrorwheel1.png';
import mirrorwheel2 from '../../../../../images/mirrorwheel2.png';
import opentrunk from '../../../../../images/opentrunk.png';
import lowbattery from '../../../../../images/lowbattery.png';
import locationmark from '../../../../../images/locationmark.png';
import chargermark from '../../../../../images/chargermark.png';
import '../../driverFaq.css';

const AutzuEVDataAll = () => {
  return (
    <Fragment>
      <Fragment>
        <h4 className="subtitle">How do I open the doors?</h4>
        <p>
          To open the door, push in on the far right side of the handle,
          with your thumb and pull the handle. To get out, press the button
          located at the top of the handle inside the vehicle.
        </p>
        <br />
        <div style={{ textAlign: 'center' }}>
          <img
            src={opendoor1}
            style={{ width: '200px', height: '200px' }}
          />
          <img src={opendoor2} className="openDoor-image" />
        </div>
        <br />
        <h4 className="subtitle">How do I start the electric motor?</h4>
        <p>
          Head to your dashboard and select “Start motor” to start the
          motor of the vehicle assigned to you.
        </p>
        <br />
        <p>
          <strong>
            If you leave the seat anytime during your booking, the car will
            be disabled and you will need to press the “Start Motor” button
            again to select a gear and continue driving.
          </strong>
        </p>
        <br />
        <div style={{ textAlign: 'center' }}>
          <img
            src={lockunlock1}
            style={{ width: '200px', height: '455px' }}
          />
          <img
            src={lockunlock2}
            style={{ width: '200px', height: '455px' }}
          />
        </div>
        <br />
        <h4 className="subtitle">How do I change gears?</h4>
        <p>
          To switch gears, hold the brake pedal down with your foot and
          shift the gear lever located on the right side behind the
          steering wheel.
        </p>
        <br />
        <p>
          Push down for Drive, push up for Reverse. Press the button at the
          end of the gear lever for Park.
        </p>
        <br />
        <div style={{ textAlign: 'center' }}>
          <img className="changeGear-image" src={changegear} />
        </div>
        <br />
        <h4 className="subtitle">
          How do I adjust the mirrors and steering wheel?
        </h4>
        <p>
          You can access the option to adjust your mirrors or steering
          wheel using the central display or voice command. Changing the
          rearview mirror is done manually like most vehicles.{' '}
          <strong>
            Click{' '}
            <a
              className="faq__panel--link"
              href="https://youtu.be/9OZtdixfWug">
              here
            </a>{' '}
            to view the video tutorial
          </strong>
          .
        </p>
        <br />
        <ol>
          <li>
            <strong>Central display: </strong>
            select Controls (vehicle icon) {'>'} Quick Controls {'>'}
            choose Mirrors or Steering Wheel and then use the control on
            the left side of the steering wheel to make your adjustments.
          </li>
        </ol>
        <br />
        <div style={{ textAlign: 'center', flexDirection: 'column' }}>
          <img src={mirrorwheel1} className="mirrorWheel-image" />
          <img src={mirrorwheel2} className="mirrorWheel-image" />
        </div>
        <br />
        <h4 className="subtitle">
          How do I open the trunk or charging port?
        </h4>
        <p>
          You can open the front trunk, back trunk or charging port by
          tapping on the area that you would like to open from the central
          display.
        </p>
        <br />
        <div style={{ textAlign: 'center' }}>
          <img className="openTrunk-image" src={opentrunk} />
        </div>
        <br />
        <h4 className="subtitle">How do I turn on the hazard lights?</h4>
        <div>
          <p>
            The hazard light button is located above you in front of the
            rearview mirror.{' '}
          </p>
        </div>
        <br />
        <h4 className="subtitle">
          How do I adjust the climate control or access the windshield
          wiper controls?
        </h4>
        <div>
          <p>
            Using the central display, you can adjust your climate by
            selecting one of the icons along the bottom of the screen.
          </p>
          <br />
          <p>
            To adjust your windshield wiper controls, select the windshield
            wiper icon on the central display or you can press the
            windshield wiper button (on the handle) located on your left
            behind the steering wheel.
          </p>
        </div>
        <br />
        <h4 className="subtitle">
          Why does the vehicle brake/slow down when I release the
          accelerator pedal? What is regenerative braking?
        </h4>
        <div>
          <p>
            When you are driving and your foot is taken off of the pedal,
            the vehicle is braking and recapturing the energy that was
            released so that it can be used later on. Most electric
            vehicles and hybrids have regenerative braking which is when
            the vehicle’s kinetic energy converts into chemical energy and
            is then stored in the battery to be used later. This feature
            cannot be turned off.
          </p>
        </div>
        <br />
        <p>
          If the battery % is too low to complete your booking, head to the
          nearest Tesla Supercharger to charge your vehicle for 20-60
          minutes. You will be automatically credited for the time spent
          charging the vehicle using a fast charger 30 minutes after your
          booking has ended. Using unauthorized chargers is strictly
          prohibited (non Tesla or non Autzu).
        </p>
        <br />
        <h4 className="subtitle">
          What should I do if the vehicle has a low battery level?
        </h4>
        <p>
          If the battery % is too low to complete your booking, head to the
          nearest Tesla Supercharger or any public third-party charging
          station to charge your vehicle for 20-60 minutes.
        </p>
        <br />
        <div style={{ textAlign: 'center' }}>
          <img
            src={lowbattery}
            style={{ width: '200px', height: '455px' }}
          />
        </div>
        <br />
        <h4 className="subtitle">
          Where can I find the nearest Supercharger?
        </h4>
        <p>
          To find the nearest Tesla Supercharger to you, check the Google
          Maps link{' '}
          <a
            className="faq__panel--link"
            href="https://goo.gl/maps/rdwFC5pdkqFUEUuJA"
            target="_blank">
            <b> here</b>
          </a>{' '}
          . Alternatively, you can use the voice command function by
          holding down the two scroll buttons on the steering wheel and
          saying, “Navigate to the nearest supercharger” or, you can use
          the central display and select the electric icon with the circle
          around it located at the bottom right of the screen. You can also
          use the{' '}
          <a
            className="faq__panel--link"
            href="https://www.plugshare.com/"
            target="_blank">
            <b> Plugshare</b>
          </a>{' '}
          or
          <a
            className="faq__panel--link"
            href="https://www.chargepoint.com/drivers/mobile"
            target="_blank">
            <b> ChargePoint</b>
          </a>{' '}
          apps to locate a charger nearest to you but must make sure that
          you have an adapter for these chargers.
        </p>
        <br />
        <p>
          The following locations are closest to our Downtown hub at 621
          King Street West:
        </p>
        <br />
        <div style={{ flexDirection: 'column' }}>
          <div>
            <img
              src={locationmark}
              style={{
                width: '16px',
                height: '21px',
                position: 'relative',
                bottom: '5px',
                marginRight: '5px'
              }}
            />
            <strong>Etobicoke, ON</strong>
          </div>
          <div>CF Sherway Gardens</div>
          <div>25 The West Mall</div>
          <div>Etobicoke, ON M9C 1B8</div>
        </div>
        <br />
        <div style={{ flexDirection: 'column' }}>
          <div>
            <img
              src={chargermark}
              style={{
                width: '21px',
                height: '21px',
                position: 'relative',
                bottom: '5px',
                marginRight: '5px'
              }}
            />
            <strong>Plugshare - Downtown - Toronto, ON </strong>
          </div>
          <div>700 Bay Street</div>
          <div>Toronto, ON M5G 1Z6</div>
        </div>
        <br />
        <div style={{ flexDirection: 'column' }}>
          <div>
            <img
              src={chargermark}
              style={{
                width: '21px',
                height: '21px',
                position: 'relative',
                bottom: '5px',
                marginRight: '5px'
              }}
            />
            <strong>Plugshare - Downtown - Toronto, ON </strong>
          </div>
          <div>MaRS</div>
          <div>101 College Street</div>
          <div>Toronto, ON M5G 1L7</div>
        </div>
        <br />
        <div style={{ flexDirection: 'column' }}>
          <div>
            <img
              src={chargermark}
              style={{
                width: '21px',
                height: '21px',
                position: 'relative',
                bottom: '5px',
                marginRight: '5px'
              }}
            />
            <strong>Plugshare - Downtown - Toronto, ON </strong>
          </div>
          <div>St. Joseph’s Health Center - Tranquility Entrance</div>
          <div>30 The Queensway</div>
          <div>Toronto, ON M6R 1B5</div>
        </div>
        <br />
        <h4 className="subtitle">Who pays for Supercharging?</h4>
        <div>
          <p>
            You must pay for all charging costs associated with your
            assigned electric vehicle. Tesla charging fees will be applied
            to your Autzu account and any third-party or public charging
            must be paid immediately with your preferred payment method.
          </p>
        </div>
        <br />
        <h4 className="subtitle">What are Supercharger idle fees?</h4>
        <div className="faq__column--container">
          <p>
            Idle fees apply to any car occupying a Supercharger if the
            station is at 50% capacity or more and the charge session is
            complete (100% battery). You have 5 minutes to remove the
            mobile connector from the vehicle and head to your next
            destination or the following fee(s) will apply:
          </p>
          <br />
          <table className="faq__table">
            <thead>
              <th
                className="faq__table__th"
                style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
                Description
              </th>
              <th
                className="faq__table__th"
                style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
                Currency
              </th>
              <th
                className="faq__table__th"
                style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
                Idle fee (per minute)
              </th>
              <th
                className="faq__table__th"
                style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
                Idle fee (per minute) when the station is 100% occupied
              </th>
            </thead>
            <tbody>
              <tr>
                <td className="faq__table__td">United States</td>
                <td className="faq__table__td">USD</td>
                <td
                  className="faq__table__td"
                  style={{ textAlign: 'right' }}>
                  $0.50
                </td>
                <td
                  className="faq__table__td"
                  style={{ textAlign: 'right' }}>
                  $1.00
                </td>
              </tr>
              <tr>
                <td className="faq__table__td">Canada</td>
                <td className="faq__table__td">CAD</td>
                <td
                  className="faq__table__td"
                  style={{ textAlign: 'right' }}>
                  $0.50
                </td>
                <td
                  className="faq__table__td"
                  style={{ textAlign: 'right' }}>
                  $1.00
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Fragment>
    </Fragment>
  );
};

export default AutzuEVDataAll;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/StartVehicleData/AutzuEVData/AutzuEVDataAll.js